import IconButton from './IconButton';

export type { IIconButtonProps } from './IconButton.types';
export default IconButton;
